var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.50022 43.0005C7.72922 43.0005 7.08322 42.4155 7.00722 41.6485C6.93222 40.8805 7.44922 40.1805 8.20622 40.0295C18.7012 37.9305 19.4452 26.9965 19.2172 22.0005H11.5002C10.8942 22.0005 10.3472 21.6355 10.1142 21.0745C9.88122 20.5135 10.0102 19.8685 10.4392 19.4395L24.4392 5.4395C25.0252 4.8535 25.9742 4.8535 26.5602 5.4395L40.5602 19.4395C40.9892 19.8685 41.1182 20.5135 40.8852 21.0745C40.6522 21.6355 40.1062 22.0005 39.5002 22.0005H31.8052C31.0702 27.6335 27.3372 43.0005 8.50022 43.0005Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow-up.6393429dfc146ed150fbe0aa274c13ae.svg";
export { ForwardRef as ReactComponent };